import { ComponentProps } from '@app/participant-fields';
import { Criterion } from 'queries';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { CheckboxesToArrayField } from '@app/form';
import { useCheckBoxToCriterion } from './useCheckBoxToCriterion';
import {
  useOnCriterionChange,
  useAddQuotaButtonHandler,
} from './useCriterionQuotasHooks';
import { AddQuotaButton } from 'components';
import { CriterionQuotaList } from './CriterionQuotaList';

const useStyles = createUseStyles((theme: Theme) => ({
  criterionContainer: {
    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase * 2,
  },
  quotaContainer: {
    borderRadius: theme.borderRadius.std,
    paddingTop: theme.marginBase,
  },
  checkboxContainer: {
    margin: 0,
    minWidth: 150,
    flex: 1,
    maxWidth: '100%',
  },
  checkList: {
    margin: 0,
    gap: theme.marginBase,
    alignItems: 'center',
  },
  quota: {
    backgroundColor: theme.colors.white,
  },
}));

export const CriterionCheckboxSelect = ({
  field,
  onChange,
  value: criterion,
  allowedFields,
  criteria,
  numberOfParticipantRequired,
  ...props
}: ComponentProps<Criterion>) => {
  const classes = useStyles();
  const options = props.options || field.choices || [];

  const showQuotas = !!criterion.quotas;
  const handleQuotasButton = useAddQuotaButtonHandler({
    showQuotas,
    criterion,
    onChange,
    numberOfParticipantRequired,
    options,
  });

  const onCriterionChange = useOnCriterionChange({
    showQuotas,
    criterion,
    onChange,
    numberOfParticipantRequired,
  });

  const [values, _onChange] = useCheckBoxToCriterion(
    criterion,
    onCriterionChange,
    options,
  );

  return (
    <>
      <div className={classes.criterionContainer}>
        <CheckboxesToArrayField
          label={field.label}
          options={options as { label: string; value: string }[]}
          values={values}
          name="fields"
          onChange={_onChange}
          noMargin
          checkboxClassName={classes.checkboxContainer}
          checkboxListClassName={classes.checkList}
          rightAction={
            <AddQuotaButton value={showQuotas} onClick={handleQuotasButton} />
          }
        />
      </div>
      {showQuotas && (
        <div className={classes.quotaContainer}>
          <CriterionQuotaList
            criterion={criterion}
            options={options}
            numberOfParticipantRequired={numberOfParticipantRequired}
            onChange={onChange}
          />
        </div>
      )}
    </>
  );
};
